/**
 * Created by mauget on 3/30/16.
 */

// PageCaptureController.js

import html2canvas  from 'html2canvas';
import constants    from 'Constants.js';
import listService  from 'ListService.js';

// The physical page. Logical pages move in and out of this DOM parent.s
const PAGE_SOURCE = constants.FORM_RAW_ID; //'aForm';


//=========================================================================================================
// Centralized controller singleton that stamps out a copy of the physical page as a thumbnail canvas.
// Note that it merely copies the image rendered as a page. Thus, to populate multiple thumbnails, all
// must have a turn at having their pages rendered in the DOM. During an XML load this could be done
// under a multiple promise resolution without delaying the user's interaction withthe page.
//
//=========================================================================================================
class PageCaptureController {

    // Publicly exposed read-only. Perhaps a template could use it.
    static get TN_HEIGHT() { return 100-2; }
    static get TN_WIDTH()  { return 200-2; }


    //=======================================================================
    // Captures the page to the target ID, a thumbnail element
    //=======================================================================
    captureThumbnail(pageId = listService.currentPageId) {

        if (constants.HAS_THUMBNAILS) {

            if (pageId) {
                // Tee up the processing to run on next cycle
                window.setTimeout(evt => ( this._captureThumbnail(this._tnIdForPageId(pageId))), 0);
            } else {
            }
        }
    }

    //=======================================================================
    // Captures all thumbnails from their page elements
    //=======================================================================
    populateAllThumbnails() {

        if (constants.HAS_THUMBNAILS) {

            // Query all thumbnail parent divs, display each, briefly
            $("[id^='pgref-']").each(
                (i, e) => window.setTimeout(
                    () => $(constants.ID_SEL + e.id).trigger('click'), 0));
        }
    }

    //=======================================================================
    // Private logic to copy the current physical page image to a
    // scaled thumbnail-aized canvase;
    //=======================================================================
    _scaleCanvas( oldCanvas ) {

        // Create a new canvas
        const newCanvas = document.createElement('canvas');
        const ctx = newCanvas.getContext('2d');

        // Set dimensions to thumbnail size
        newCanvas.width = PageCaptureController.TN_WIDTH;
        newCanvas.height = PageCaptureController.TN_HEIGHT;

        // Scale new canvas;
        // TODO dynamically scale proportionally to current page size obtained from listservice.
        ctx.scale(0.35, 0.35);

        // Draw the old canvas into the new canvas
        ctx.drawImage(oldCanvas, 0, 0);

        // Result is the new canvas
        return newCanvas;
    }


    //=======================================================================
    // Private core logic to capture the current page rendition into a
    // thumbnail targetId;
    //=======================================================================
    _captureThumbnail( targetId ) {
        const
            $target = $(constants.ID_SEL + targetId),
            source = document.getElementById(PAGE_SOURCE),
            options = {};

        options.isLogging = false;

        html2canvas(source, options)
            .then(canvas => $target.empty().append(this._scaleCanvas(canvas)))
            .catch(err => console.log(err));
    }


    //=======================================================================
    // Private JQuery select to find the thumbnail ID for the
    // given page ID.
    //=======================================================================
    _tnIdForPageId( pageId ) {
        console.log(pageId);

        const tnId = `[data-page='${pageId}']`;
        // console.log( $(tnId).attr('id') );

        return $(tnId).attr('id');
    }


}

const pageCaptureController = new PageCaptureController();
export default pageCaptureController;
